import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';


import { Filter } from '../components/reports/filter';
import { environment } from '../../environments/environment';
import { Order } from '../components/reports/order';
import { catchError, map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint;
  // httpHeaders = new HttpHeaders({ 'Content-type': 'application/json'});

  getWards(): Observable<any> {
    return this.http.get<any>(this.urlEndPoint + '/api/wards');
  }

  getOrders(filter: Filter): Observable<any> {

    let _filter = Object.assign({}, filter)
    delete _filter.state_list;
    delete _filter.searchOnlyByNameOrSurname;


    _filter.orderState = new Array();
    filter.orderState.forEach(state => {
      _filter.orderState = _filter.orderState.concat(filter.state_list[state].id)
    });

    if (_filter.orderId != undefined || _filter.patientIds != undefined) {
      _filter.startDate = new Date()
      _filter.endDate = new Date();
      if (_filter.minDate == 0) {
        _filter.startDate.setMonth(_filter.startDate.getMonth() - 999);
      }
      else {
        _filter.startDate.setMonth(_filter.startDate.getMonth() - _filter.minDate);
      }
    }
    if (_filter.patientIds == undefined) _filter.patientIds = new Array;

    _filter.startDate = _filter.getStartDate() + " 00:00:00";
    _filter.endDate = _filter.getEndDate() + " 23:59:59";

    delete _filter.minDate;
    delete _filter.group;
    delete _filter.name;
    delete _filter.surname;


    return this.http.post<any>(this.urlEndPoint + '/orders/search', _filter);
  }

  getPatientOrders(filter: Filter): Observable<any> {
    let _filter = Object.assign({}, filter)

    delete _filter.state_list;
    delete _filter.searchOnlyByNameOrSurname;

    _filter.startDate = new Date();
    _filter.endDate = new Date();
    if (_filter.minDate == 0) {
      _filter.startDate.setMonth(_filter.startDate.getMonth() - 999);
    }
    else {
      _filter.startDate.setMonth(_filter.startDate.getMonth() - _filter.minDate);
    }

    _filter.startDate = _filter.getStartDate() + " 00:00:00";
    _filter.endDate = _filter.getEndDate() + " 23:59:59";

    delete _filter.minDate;

    return this.http.post<any>(this.urlEndPoint + '/orders/search', _filter);
  }

  getPatients(filter: Filter): Observable<any> {
    ///search-patients-filter by Group and MinDate
    const params = new URLSearchParams();

    params.set('group', filter.group.toString());
    if (filter.dni) params.set('fiscalCode', filter.dni.toString());
    if (filter.name) params.set('name', filter.name.toString());
    if (filter.surname) params.set('surname', filter.surname.toString());
    if (filter.hc) params.set('healthCode', filter.hc.toString());
    params.set('minDate', filter.minDate.toString())

    return this.http.get<any>(this.urlEndPoint + '/api/search-patients-filtered?' + params.toString());
  }

  getHistory(filter: Filter, history) {
    let _filter = Object.assign({}, filter)

    delete _filter.state_list;
    delete _filter.searchOnlyByNameOrSurname;
    delete _filter.orderState;
    delete _filter.startDate;
    delete _filter.endDate;
    delete _filter.minDate;
    delete _filter.group;

    if (history == 2)
      _filter.wards = new Array;

    return this.http.post<any>(this.urlEndPoint + '/orders/patient', _filter);
  }

  getReports(orders: any): Observable<any> {
    const params = new URLSearchParams();
    return this.http.post(this.urlEndPoint + '/reports/get', orders, { responseType: 'blob' }).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        console.error();
        return err;
      })
    );
  }

  getResults(order): Observable<any> {
    return this.http.post<any>(this.urlEndPoint + '/results', order);
  }

  getInfo(order: Order): Observable<any> {
    const params = new URLSearchParams();
    params.set('orderid', order.orderId);
    params.set('orderdate', order.orderDate);
    params.set('source', order.source.toString());
    return this.http.get<any>(this.urlEndPoint + '/orders/log?' + params.toString());
  }

}
